module.exports = __webpack_public_path__ + "static/media/lazer1.65faf3ea.jpg";